import { AuditableEntity } from "./audible-entity.model";
import { DeliveryAddress } from "./delivery-address.model";
import { EANCodeType } from "./ean-code-type.model";

export class EANCode extends AuditableEntity {

    constructor(_Id?: number, _EANNumber?: string, _DeliveryAddressId?: number, _EANCodeTypeId?: number, _IsActive?: boolean,
        _CreatedBy?: string, _CreatedDate?: Date, _UpdatedBy?: string, _UpdatedDate?: Date, _DeletedBy?: string, _DeletedDate?: Date) {

        super(_CreatedBy, _CreatedDate, _UpdatedBy, _UpdatedDate, _DeletedBy, _DeletedDate);

        this.Id = _Id;
        this.EANNumber = _EANNumber;
        this.DeliveryAddressId = _DeliveryAddressId;
        this.EANCodeTypeId = _EANCodeTypeId || 1;
        this.IsActive = _IsActive || true;

        this.DeliveryAddress = null;
        this.EANCodeType = null;
    }

    public Id: number;
    public EANNumber: string;
    public DeliveryAddressId: number;
    public EANCodeTypeId: number;
    public IsActive: boolean;

    public DeliveryAddress: DeliveryAddress;
    public EANCodeType: EANCodeType;
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./ClientApp/app/models/ean-code.model.ts